import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React, { useEffect } from 'react';
import './index.scss';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';

import './assets/css/bootstrap.min.css';
import './assets/css/style.css';

import { unregister } from './registerServiceWorker';

import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from '@mui/material/styles';
import theme from './assets/customisedMUI/theme';
// import { PublicClientApplication } from '@azure/msal-browser';
// import { MsalProvider } from '@azure/msal-react';
// import { msalConfig } from 'config/msal';
import { GoogleOAuthProvider } from '@react-oauth/google';
import _ from 'lodash';

//redux
import { Provider } from 'react-redux';

import store from './store/';
import { PermissionProvider } from 'permissions/PermissionContext';
import { PostHogProvider, PostHogErrorBoundary } from 'posthog-js/react';
import * as Sentry from '@sentry/react';

//intercom
import { IntercomProvider } from 'react-use-intercom';
import { INTERCOM_APP_ID } from './constants';

// const msalInstance = new PublicClientApplication(msalConfig);
const clientId = '651065819092-t97i9tfuknprp3cl13cg2bgf6c3dapvn.apps.googleusercontent.com';
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
const options = {
    api_host: 'https://us.i.posthog.com',
    defaults: '2025-05-24',
    //ENABLING ERROR TRACKING
    capture_exceptions: true,

    //DISABLING AUTOCAPTURE
    autocapture: false,
    capture_pageview: false,
    capture_pageview_performance: false,
    disable_session_recording: true,

    // loaded: (ph) => {
    //     ph.opt_out_capturing(); //preventing other automatic events.
    // },
};

const apiKey =
    window.location.hostname.includes('lifeskillsgo.com') && !window.location.hostname.includes('-staging')
        ? 'phc_SyrUqaYTzykPhL9SDiykmyJJ7j2c6HTZx2j53ioASEU'
        : 'phc_cXHYyd49ojjxP2detCb43tEwglRf2fjavzu3IN0IyYv';

Sentry.init({
    dsn: 'https://30ee53d44690c98a7019a924b346eb31@o4509952834928640.ingest.us.sentry.io/4510258388926464',
    environment: window.location.hostname.includes('lifeskillsgo.com')
        ? window.location.hostname.includes('-staging')
            ? 'staging'
            : 'production'
        : 'development', // sets the environment
    sendDefaultPii: false, //info like user's ip address, user info etc is not sent to sentry
    sampleRate: 0.05, //how much of your app’s request traffic to sample for performance tracing. 0.2 = capture 20% of requests. Sentry randomly picks 1 out of 5 requests to record in detail.
});

const app = (
    <Provider store={store}>
        <PostHogProvider apiKey={apiKey} options={options}>
            <BrowserRouter>
                <ThemeProvider theme={theme}>
                    <PostHogErrorBoundary fallback={<ErrorBoundary />}>
                        <ErrorBoundary>
                            <GoogleOAuthProvider clientId={clientId}>
                                {/* <MsalProvider instance={msalInstance}> */}
                                <PermissionProvider>
                                    <IntercomProvider appId={INTERCOM_APP_ID}>
                                        <App />
                                    </IntercomProvider>
                                </PermissionProvider>
                                {/* </MsalProvider> */}
                            </GoogleOAuthProvider>
                        </ErrorBoundary>
                    </PostHogErrorBoundary>
                </ThemeProvider>
            </BrowserRouter>
        </PostHogProvider>
    </Provider>
);

root.render(app);

window.lsgo = {};
window.lsgo.registerLsgoFunction = (key, fun) => _.set(window.lsgo, key, fun);

unregister();
